<script lang="ts">
  import a11yClick from '../../utils/a11y-click';

  export let options: Array<{value: string | null; label: string}>;
  export let value: string | null;
  export let name: string;
  export let disabled = false;

  function handleKeyPress(event: KeyboardEvent) {
    if (
      document.activeElement &&
      (document.activeElement as HTMLElement).click &&
      a11yClick(event)
    ) {
      (document.activeElement as HTMLElement).click();
    }
  }
</script>

<style lang="postcss">
  .toggleButtonGroup {
    display: inline-flex;
    align-items: center;
  }

  .toggleButton {
    height: var(--ubilabs-toggle-button-height);
    padding: var(--ubilabs-toggle-button-padding);
    outline: none;
    border: var(--ubilabs-toggle-button-border);
    border-radius: 0;
    background-color: var(--ubilabs-toggle-button-background-color);
    color: var(--ubilabs-toggle-button-label-color);
    font-size: var(--ubilabs-button-font-size);
    line-height: var(--ubilabs-button-line-height);
    letter-spacing: var(--ubilabs-button-letter-spacing);
    white-space: nowrap;
  }

  .toggleButton:first-child {
    border-top-left-radius: var(--ubilabs-toggle-button-border-radius);
    border-bottom-left-radius: var(--ubilabs-toggle-button-border-radius);
  }

  .toggleButton:last-child {
    border-top-right-radius: var(--ubilabs-toggle-button-border-radius);
    border-bottom-right-radius: var(--ubilabs-toggle-button-border-radius);
  }

  .toggleButton:not(:last-child) {
    margin-right: calc(var(--ubilabs-toggle-button-border-width) * -1);
  }

  .toggleButton:not(.disabled):hover,
  .toggleButton:not(.disabled):focus-visible {
    background-color: var(--ubilabs-toggle-button-hover-background-color);
  }

  .toggleButton:not(.disabled):focus-visible {
    z-index: 2;
    box-shadow: var(--ubilabs-focus-box-shadow);
  }

  .toggleButton.active,
  .toggleButton.active:not(.disabled):hover,
  .toggleButton.active:not(.disabled):focus-visible {
    z-index: 2;
    border-color: var(--ubilabs-toggle-button-active-border-color);
    background-color: var(--ubilabs-toggle-button-active-background-color);
    color: var(--ubilabs-toggle-button-active-label-color);
    font-weight: 500;
  }

  .toggleButton.disabled {
    border-color: var(--ubilabs-toggle-button-disabled-border-color);
    background-color: var(--ubilabs-toggle-button-disabled-background-color);
    color: var(--ubilabs-toggle-button-disabled-label-color);
  }

  .toggleButton.disabled.active {
    border-color: var(--ubilabs-toggle-button-disabled-active-border-color);
    background-color: var(
      --ubilabs-toggle-button-disabled-active-background-color
    );
    color: var(--ubilabs-toggle-button-disabled-active-label-color);
  }

  @media (max-width: 639px) {
    .toggleButtonGroup {
      flex-direction: column;
      width: 100%;
      max-width: var(--ubilabs-input-width);
    }

    .toggleButton {
      width: 100%;
      text-align: center;
    }

    .toggleButton:first-child {
      border-top-right-radius: var(--ubilabs-toggle-button-border-radius);
      border-bottom-left-radius: 0;
    }

    .toggleButton:last-child {
      border-top-right-radius: 0;
      border-bottom-left-radius: var(--ubilabs-toggle-button-border-radius);
    }

    .toggleButton:not(:last-child) {
      margin-right: 0;
      margin-bottom: calc(var(--ubilabs-toggle-button-border-width) * -1);
    }
  }
</style>

<div class="toggleButtonGroup {$$props.class}">
  {#each options as option}
    <label
      class="toggleButton {option.value === value && 'active'} {disabled &&
        'disabled'}"
      tabIndex={disabled ? -1 : 0}
      on:keypress={handleKeyPress}>
      <input
        type="radio"
        {name}
        value={option.value}
        checked={option.value === value}
        bind:group={value}
        {disabled}
        hidden />
      {option.label}
    </label>
  {/each}
</div>
